import React, {Component} from 'react';
import { Trans } from 'react-i18next';
import { val } from '../util/HelpfulFunctions';

class PageHeader extends Component {

    constructor(props ){
        super(props);
        this.state = {
            title : val( props.title, '')
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.title != prevState.title)
            return Object.assign(prevState, { title: val(nextProps.title) });
        else
            return prevState;
    }

    render() {
        return (
            <div className="page-header d-flex">
                    <div><span className="page-title ml-2">{this.state.title}</span></div>
                    <div className="justify-content-end mr-2">{this.props.sideContent? this.props.sideContent(): null}</div>
            </div>
        )
    }
}


export default PageHeader;